// Configurazione sezioni CIL Wrapped 2025
// Ogni sezione contiene: id, value, description, visualType, colors, etc.

export const wrapped2025Sections = [
  {
    id: 'hero',
    type: 'hero',
    title: 'CIL Wrapped 2025',
    introText:
      'Il 2025 è stato un anno fatto di eventi, persone, attività e numeri che raccontano chi siamo.',
    introText2:
      'Questo Wrapped raccoglie i dati che hanno segnato il percorso di CIL: non opinioni, ma fatti, presenze e momenti condivisi.',
    introText3:
      "Scorri per scoprire com'è andato il nostro anno, un numero alla volta.",
  },
  {
    id: 'eventi-organizzati',
    type: 'big-number',
    value: 92,
    unit: '',
    label: 'EVENTI ORGANIZZATI',
    description:
      'In un solo anno CIL ha dato vita a 92 eventi diversi, tra gioco, educazione e socialità. Un numero che racconta continuità, presenza e tanta energia messa in campo.',
    visualType: 'big-number-hero',
    accentColor: '#ffcc00',
    bgColor: 'brand.100',
    bgImage: '/assets/wrapped-bg/1.png',
  },
  {
    id: 'giorno-eventi',
    type: 'split-card',
    title: 'Domenica',
    value: 32,
    unit: '',
    description:
      'Con ben 32 eventi organizzati. È il momento della settimana in cui la comunità si ritrova più spesso.',
    visualType: 'split-card',
    chartData: 'daysOfWeek',
    accentColor: '#3b235a',
    bgColor: 'white',
    bgImage: '/assets/wrapped-bg/2.png',
  },
  {
    id: 'evento-lungo',
    type: 'highlight-card',
    value: 21,
    unit: 'ore consecutive',
    label: 'EVENTO PIÙ LUNGO',
    description:
      "L'evento più lungo dell'anno ha superato le 21 ore senza interruzioni. Un'esperienza intensa che dimostra quanto alcune attività sappiano andare oltre il tempo standard.",
    detail: 'Notte al Munlab (6–7 settembre)',
    visualType: 'highlight-card',
    accentColor: '#ffcc00',
    bgGradient: 'linear(to-b, #3b235a, #1a202c)',
    textColor: 'gray.300',
    bgImage: '/assets/wrapped-bg/10.png',
  },
  {
    id: 'bustine-magic',
    type: 'full-width-card',
    value: 301,
    unit: '',
    label: 'BUSTINE DI MAGIC APERTE',
    description:
      "Durante draft, tornei ed eventi sono state aperte 301 bustine di Magic. Un numero che racconta quante partite, scambi e momenti di gioco hanno animato l'associazione.",
    icon: 'FaMagic',
    visualType: 'full-width-card',
    accentColor: '#ffffff',
    bgColor: '#3eb297',
    bgImage: '/assets/wrapped-bg/5.png',
  },
  {
    id: 'ghiaccioli',
    type: 'full-width-card',
    value: 612,
    unit: '',
    label: 'GHIACCIOLI CENTRO ESTIVO',
    description:
      'Nel corso del centro estivo sono stati distribuiti 612 ghiaccioli. Un piccolo dato che racchiude tante giornate calde e momenti conclusivi.',
    icon: 'FaIceCream',
    visualType: 'full-width-card',
    accentColor: '#ffffff',
    bgColor: '#36a9e1',
    bgImage: '/assets/wrapped-bg/8.png',
  },
  {
    id: 'caffe',
    type: 'minimal-card',
    value: 4.25,
    unit: 'kg',
    label: 'CAFFÈ CONSUMATO',
    description:
      'Per sostenere attività, eventi e organizzazione sono stati consumati 4,25 kg di caffè. Un carburante silenzioso che accompagna riunioni, preparativi e lunghe giornate.',
    icon: 'FaCoffee',
    visualType: 'minimal-card',
    accentColor: '#3b235a',
    bgColor: 'white',
    bgImage: '/assets/wrapped-bg/3.png',
  },
  {
    id: 'bandi',
    type: 'compact-card',
    value: 2,
    unit: '',
    label: 'BANDI ATTIVI',
    description:
      "Nel 2025 CIL ha avuto 2 bandi attivi. Un segnale concreto di attenzione alla crescita e alla sostenibilità futura dell'associazione.",
    icon: 'FaFileAlt',
    visualType: 'compact-card',
    accentColor: '#ffffff',
    bgColor: '#e95995',
    bgImage: '/assets/wrapped-bg/44.png',
  },
  {
    id: 'piante',
    type: 'image-card',
    value: 22,
    unit: '',
    label: 'PIANTE ADOTTATE IN SEDE',
    description:
      "Gli spazi di CIL ospitano oggi 22 piante curate nel tempo. Un numero che racconta l'attenzione per l'ambiente e per rendere la sede più viva e accogliente.",
    icon: 'FaLeaf',
    visualType: 'image-card',
    accentColor: '#3b235a',
    bgColor: 'white',
    bgImage: '/assets/wrapped-bg/4.png',
  },
  {
    id: 'fascia-eta',
    type: 'chart-section',
    title: '0–18 anni',
    value: 195,
    unit: 'soci',
    description:
      'La fascia 0–18 anni è la più numerosa, con 195 soci. Un numero che evidenzia il ruolo centrale delle attività rivolte a bambini e ragazzi.',
    chartData: 'ageRange',
    visualType: 'bar-chart',
    accentColor: '#36a9e1',
    bgColor: 'white',
    bgImage: '/assets/wrapped-bg/222.png',
  },
  {
    id: 'mese-soci',
    type: 'timeline-card',
    title:
      'Marzo 2025 è stato il mese con il maggior numero di nuove iscrizioni, ben',
    value: 187,
    unit: 'soci',
    description:
      "Un momento chiave dell'anno che ha segnato una forte crescita della comunità.",
    chartData: 'months',
    visualType: 'timeline-card',
    accentColor: '#3b235a',
    bgColor: '#ffcc00',
    bgImage: '/assets/wrapped-bg/7.png',
  },
  {
    id: 'composizione-anagrafica',
    type: 'chart-section',
    title: 'Composizione anagrafica',
    value: null,
    unit: '',
    description:
      'La base associativa è composta per il 43,52% da minorenni e per il 56,48% da maggiorenni. Una distribuzione equilibrata che riflette la varietà delle persone che partecipano a CIL.',
    chartData: 'demographic',
    visualType: 'donut-chart',
    accentColor: '#36a9e1',
    bgColor: 'white',
    bgImage: '/assets/wrapped-bg/333.png',
    percentages: {
      minorenni: 43.52,
      maggiorenni: 56.48,
    },
  },
  {
    id: 'eta-media',
    type: 'big-number-minimal',
    value: 21.51,
    unit: 'anni',
    label: 'ETÀ MEDIA SOCI',
    description:
      "L'età media dei soci si attesta a 21,51 anni. Un valore che racconta un'associazione giovane, ma capace di coinvolgere età diverse.",
    visualType: 'big-number-minimal',
    accentColor: '#ffffff',
    bgColor: '#3b235a',
    bgImage: '/assets/wrapped-bg/6.png',
  },
  {
    id: 'socio-attivo',
    type: 'info-card',
    title: 'Lorenzo S.',
    value: 76,
    unit: 'partecipazioni',
    introText: "Il socio più attivo dell'anno è",
    description:
      "Un dato che riconosce l'impegno costante e la presenza continuativa nelle attività di CIL.",
    visualType: 'info-card',
    accentColor: '#ffffff',
    bgColor: '#e73341',
    bgImage: '/assets/wrapped-bg/11.png',
  },
  {
    id: 'outro',
    type: 'outro',
    title: 'Questo è stato il nostro 2025.',
    closingText:
      'I numeri che hai visto raccontano attività, impegno e una comunità che continua a crescere.',
    closingText2:
      'CIL è fatta di persone che partecipano, organizzano e costruiscono insieme, ogni giorno.',
    closingText3:
      "Se vuoi farne parte anche tu, puoi tesserarti e sostenere le attività dell'associazione.",
    closingText4:
      'E per restare aggiornato su eventi, progetti e novità, seguici sui nostri canali social.',
    ctaTesseramento: {
      text: 'Tesserati a CIL',
      link: '/tesseramento',
    },
    ctaRinnova: {
      text: 'Rinnova la tessera',
      link: '/account/tesseramenti',
    },
    ctaInstagram: {
      text: 'Seguici su Instagram: @cil_associazione',
      link: 'https://www.instagram.com/cil_associazione/',
    },
  },
];
